// Button text alternatives - keeping them short enough for one line
// This variable will be available globally when this script is loaded

// High priority texts (shown 75% of the time) - Polly-branded CTAs
window.buttonTextsHighPriority = [
  'Show me, Polly!',
  'Let Polly work her magic 🔮',
  "Let's fly! 🦜",
  'See my retention roadmap',
  'Polly, do your thing!',
  'Show me the strategy',
  "I'm ready—surprise me!",
  'Build my preview',
  "Let's do this!"
];

// Low priority texts (shown 25% of the time) - fun alternatives
window.buttonTextsLowPriority = [
  'Generate a journey',
  'Chart an expedition',
  'Map your quest',
  'Forge a path',
  'Create an experience',
  'Unleash magic',
  'Make your day',
  'Engage warp drive',
  'Use the force',
  'Find a way',
  'Follow the rabbit',
  'Boldly go forward',
  'Assemble the avengers',
  'Craft a legend',
  'Ignite an adventure',
  'Discover new worlds',
  'Begin the quest',
  'Activate ludicrous speed',
  'Release the kraken',
  'Start your tour',
  'Embark on a journey',
  'Open the portal',
  'Summon a familiar',
  'Join the fellowship',
  'Unlock mystery',
  'Challenge accepted',
  'Grab your towel',
  'Say hello to your journey',
  'I\'ll be back',
  'Witness me',
  'Take the throne',
  'Traverse the multiverse',
  'Fly, you fool',
  'Climb a mountain',
  'Build something worthwhile',
  'Love your product',
  'Maximize your experience',
  'Unlock hidden benefits',
  'Get more from your purchase',
  'Transform your product',
  'Discover product secrets',
  'Enhance your investment',
  'Extend product lifespan',
  'Build product affinity',
  'Make it truly yours',
  'Become a power user',
  'Master your product',
  'Elevate your experience',
  'Connect with your purchase',
  'Love what you bought',
  'Head towards infinity',
  'Explore the beyond',
  'Allons-y!',
  'Tilt a windmill',
  'Bend and snap',
  'Make fetch happen',
  'Just keep swimming',
  'This is the way',
  'So say we all',
  'Make it so',
  'Go beyond your limits',
  'Let\'s see what happens',
  'Roll out',
  'Geronimo!',
  'Hey, listen!',
  'Don\'t stop me now',
  'Shake it off',
  'Just do it',
  'Challenge accepted',
  'Watch this',
  'Do it for the vine',
  'Go go gadget',
  'I choose you',
  'Make it work',
  'Wax on, wax off',
  'Make magic happen',
  'Unlock product potential',
  'Supercharge your product',
  'Turn possibility to reality',
  'Adventure is out there',
  'Seize the opportunity',
  'Personalize your journey',
  'One small click',
  'Let\'s roll',
  'Jump right in',
  'Adventure awaits',
  'Upgrade your experience',
  'Get more from your product',
  'Begin the transformation',
  'Unlock potential',
  'Chart your success path',
  'Boost your productivity',
  'Maximize satisfaction',
  'Transform your approach',
  'Step into the spotlight',
  'Discover hidden features',
  'Tap into expertise',
  'Set your journey in motion',
  'Light the spark',
  'Make a splash',
  'Create lasting value',
  'Level up your skills',
  'Accelerate your mastery',
  'Find your flow',
  'Embrace the adventure',
  'Press the big button',
  'Do the thing',
  'Dive in headfirst',
  'Take the scenic route',
  'Live your truth',
  'Strike a pose',
  'Glow up time',
  'Be iconic',
  'Spill the tea',
  'Bring the dramatics',
  'Make a new friend'
];

// Combined list for backwards compatibility (used by button-utils.js for history tracking)
window.buttonTexts = [...window.buttonTextsHighPriority, ...window.buttonTextsLowPriority];
